"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./polyfills");
// layout
require("./layout");
// style
require("@deepmap/hdm-web-map-sdk/styles/index.scss");
require("@deepmap/control-level-switch/styles/control-level-switch.scss");
require("@deepmap/control-routing/styles/control-routing.scss");
const system_1 = require("./util/system");
const hdm_web_map_sdk_1 = require("@deepmap/hdm-web-map-sdk");
const control_routing_1 = require("@deepmap/control-routing");
const control_level_switch_1 = require("@deepmap/control-level-switch");
const config = Object.assign({}, system_1.getConfig({
    projectName: 'mathematikon_basemap',
}), {
    target: 'deepMap-routing'
});
let startPoint, endPoint, startFeature, endFeature;
function getRoutePointFromQueryPoint(queryPoint, level) {
    const coordinates = queryPoint.center.coordinates;
    return {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
        level: level
    };
}
try {
    const map = hdm_web_map_sdk_1.DeepMapFactory.bootstrap(config);
    function routingTapHandler(queryPoint, level, features) {
        if (endPoint) {
            endPoint = null;
            startPoint = null;
        }
        if (!startPoint) {
            startPoint = getRoutePointFromQueryPoint(queryPoint, map.currentLevel);
            routingControl.display.setStart(`${startPoint.lat},${startPoint.lng}`);
            console.log(startPoint);
        }
        else if (!endPoint) {
            endPoint = getRoutePointFromQueryPoint(queryPoint, map.currentLevel);
            routingControl.display.setEnd(`${endPoint.lat},${endPoint.lng}`);
            routingControl.getRouteByRoutePoint(startPoint, endPoint, true, false, false).then(function (route) {
                console.log('<--- route', route);
            });
        }
    }
    const routingControl = new control_routing_1.ControlRouting({
        projectName: config.projectName,
        routeServiceUrl: 'https://maps.deepmap.net/routingservice',
        showDialog: true
    });
    const levelSwitchControl = new control_level_switch_1.ControlLevelSwitch();
    map.addControl(routingControl);
    map.addControl(levelSwitchControl);
    map.setMapViewControllerDidStart(function () {
        if (config.projectName === 'mathematikon_basemap') {
            map.moveToFeatureByOriginalSerial('hdmi_office', false, true);
        }
        map.addTapHandler(routingTapHandler);
    });
}
catch (e) {
    console.log('error', e);
}
